module.exports = __webpack_public_path__ + "assets/svg/Icons/32/info-gray-7d8b2b.svg";